import { useAuthQuery } from 'app/api_v2/auth/queries';
import { SplashScreen } from 'app/ui/components/SplashScreen';
import { ReactNode } from 'react';

interface CheckIsLoggedInGuardProps {
  children: ReactNode;
}

export const CheckIsLoggedInGuard = (props: CheckIsLoggedInGuardProps) => {
  const { children } = props;
  const { isLoading } = useAuthQuery();

  if (isLoading) {
    return <SplashScreen />;
  }

  return <>{children}</>;
};

export default CheckIsLoggedInGuard;
